import React from "react";

const Loader1 = () => {
  return <div className="loader1"></div>;
};

export default Loader1;
